<template>
  <div class="customer-home">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-left">
        <span class="header-title">{{ $t('customer.Home.line6_text') }}</span>
      </div>
      <button class="header-icon" @click="showMenu = !showMenu">☰</button>
    </header>

    <!-- 价格标签 -->
    <div class="price-tag contract">
      📍 当前价格：协议价 ★
    </div>

    <!-- 搜索框 -->
    <div class="search-box">
      <input 
        type="text" 
        class="search-input" 
        :placeholder="$t('customer.Home.line21_placeholder')" 
        @focus="goToSearch"
        readonly
      />
    </div>

    <!-- 分类导航 -->
    <div class="category-nav">
      <div 
        v-for="cat in categories" 
        :key="cat.id"
        :class="['category-item', { active: currentCategory === cat.id }]"
        @click="filterCategory(cat.id)"
      >
        {{ cat.icon }} {{ cat.name }}
      </div>
    </div>

    <!-- 商品网格 -->
    <div class="product-grid">
      <div 
        v-for="product in filteredProducts" 
        :key="product.id"
        class="product-card"
        @click="goToDetail(product)"
      >
        <div class="product-image">{{ product.image }}</div>
        <div class="product-info">
          <div class="product-name">{{ product.name }}</div>
          <div class="product-name-en">{{ product.nameEn }}</div>
          <div class="product-price">
            SGD {{ product.price.toFixed(2) }}
            <span class="product-price-old" v-if="product.oldPrice">SGD {{ product.oldPrice.toFixed(2) }}</span>
          </div>
          <div :class="['product-stock', { low: product.stock < 10 }]">
            库存：{{ product.stock }}{{ product.unit }}
            <span v-if="product.stock < 10">{{ $t('customer.Home.line57_text') }}</span>
          </div>
          <div class="product-actions">
            <button class="btn-detail" @click.stop="goToDetail(product)">{{ $t('customer.Home.line60_text') }}</button>
            <button class="btn-add" @click.stop="addToCart(product)">{{ $t('customer.Home.line61_text') }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部导航 -->
    <nav class="bottom-nav">
      <button class="nav-item active" @click="goToTab('home')">
        <span class="nav-item-icon">🏠</span>
        <span>{{ $t('common.home') }}</span>
      </button>
      <button class="nav-item" @click="goToTab('orders')">
        <span class="nav-item-icon">📋</span>
        <span>{{ $t('common.orders') }}</span>
        <span v-if="pendingOrders > 0" class="cart-badge">{{ pendingOrders }}</span>
      </button>
      <button class="nav-item" @click="goToTab('cart')">
        <span class="nav-item-icon">🛒</span>
        <span>{{ $t('common.cart') }}</span>
        <span v-if="cartCount > 0" class="cart-badge">{{ cartCount }}</span>
      </button>
      <button class="nav-item" @click="goToTab('profile')">
        <span class="nav-item-icon">👤</span>
        <span>{{ $t('common.profile') }}</span>
      </button>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CustomerHome',
  data() {
    return {
      currentTab: 'home',
      currentCategory: 'all',
      showMenu: false,
      pendingOrders: 3,
      cartCount: 5,
      categories: [
        { id: 'all', name: '全部', icon: '' },
        { id: 'veg', name: '蔬菜', icon: '🥬' },
        { id: 'fruit', name: '水果', icon: '🍎' },
        { id: 'meat', name: '肉类', icon: '🥩' },
        { id: 'dry', name: '干货', icon: '🍚' },
        { id: 'cold', name: '冷冻', icon: '❄️' }
      ],
      products: [
        { id: 1, name: '新鲜白菜', nameEn: 'Fresh Cabbage', price: 2.5, oldPrice: 3.0, stock: 100, unit: 'kg', image: '🥬', category: 'veg' },
        { id: 2, name: '红富士苹果', nameEn: 'Red Apple', price: 4.8, oldPrice: 5.5, stock: 50, unit: 'kg', image: '🍎', category: 'fruit' },
        { id: 3, name: '精品五花肉', nameEn: 'Pork Belly', price: 12.0, oldPrice: 14.0, stock: 30, unit: 'kg', image: '🥩', category: 'meat' },
        { id: 4, name: '东北大米', nameEn: 'Jasmine Rice', price: 3.5, oldPrice: null, stock: 200, unit: 'kg', image: '🍚', category: 'dry' },
        { id: 5, name: '冷冻虾仁', nameEn: 'Frozen Shrimp', price: 18.0, oldPrice: 22.0, stock: 8, unit: 'kg', image: '🦐', category: 'cold' },
        { id: 6, name: '新鲜生菜', nameEn: 'Fresh Lettuce', price: 1.8, oldPrice: 2.2, stock: 150, unit: 'kg', image: '🥬', category: 'veg' }
      ]
    };
  },
  computed: {
    ...mapGetters(['userName']),
    filteredProducts() {
      if (this.currentCategory === 'all') {
        return this.products;
      }
      return this.products.filter(p => p.category === this.currentCategory);
    }
  },
  methods: {
    filterCategory(catId) {
      this.currentCategory = catId;
    },
    goToSearch() {
      // TODO: 跳转到搜索页
      console.log('go to search');
    },
    goToDetail(product) {
      // TODO: 跳转到商品详情
      console.log('go to detail', product);
    },
    addToCart(product) {
      // TODO: 添加到购物车
      console.log('add to cart', product);
    },
    goToTab(tab) {
      this.currentTab = tab;
      const routes = {
        home: '/customer/home',
        orders: '/purchase-order',
        cart: '/shopping-cart',
        profile: '/stall/profile'  // 档口用户的个人中心
      };
      if (routes[tab]) {
        this.$router.push(routes[tab]);
      }
    }
  }
};
</script>

<style scoped>
.customer-home {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 60px;
}

.header {
  background: white;
  border-bottom: 1px solid #eee;
  padding: calc(12px + env(safe-area-inset-top, 0px)) 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
}

.header-icon {
  font-size: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
}

.header-icon:active {
  background: #f5f5f5;
}

.price-tag {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  margin: 12px 16px;
  text-align: center;
}

.search-box {
  padding: 12px 16px;
  background: white;
  margin-bottom: 8px;
}

.search-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 14px;
  background-color: #f5f5f5;
  color: #999;
}

.category-nav {
  background: white;
  padding: 0;
  overflow-x: auto;
  white-space: nowrap;
  margin-bottom: 8px;
  border-bottom: 1px solid #eee;
  -webkit-overflow-scrolling: touch;
}

.category-nav::-webkit-scrollbar {
  height: 3px;
}

.category-item {
  display: inline-block;
  padding: 12px 16px;
  font-size: 13px;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  color: #666;
}

.category-item.active {
  color: #667eea;
  border-bottom-color: #667eea;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 8px;
}

.product-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #f0f0f0;
  transition: all 0.3s;
}

.product-card:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.product-image {
  width: 100%;
  height: 120px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
}

.product-info {
  padding: 10px;
}

.product-name {
  font-size: 13px;
  font-weight: bold;
  color: #333;
  line-height: 1.3;
  margin-bottom: 4px;
}

.product-name-en {
  font-size: 11px;
  color: #999;
  margin-bottom: 6px;
}

.product-price {
  font-size: 14px;
  font-weight: bold;
  color: #f5576c;
  margin-bottom: 4px;
}

.product-price-old {
  font-size: 11px;
  color: #999;
  text-decoration: line-through;
  margin-left: 4px;
}

.product-stock {
  font-size: 11px;
  color: #999;
  margin-bottom: 6px;
}

.product-stock.low {
  color: #f5576c;
}

.product-actions {
  display: flex;
  gap: 4px;
}

.btn-detail {
  flex: 1;
  padding: 6px;
  background: #f5f5f5;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #666;
  font-size: 11px;
}

.btn-add {
  flex: 1;
  padding: 6px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  font-weight: bold;
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-around;
  z-index: 100;
  height: 56px;
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  font-size: 11px;
  border: none;
  background: none;
  position: relative;
}

.nav-item.active {
  color: #667eea;
}

.nav-item-icon {
  font-size: 24px;
  margin-bottom: 2px;
}

.cart-badge {
  position: absolute;
  top: 4px;
  right: 50%;
  margin-right: -20px;
  background: #f5576c;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
}
</style>
